import React from "react";
import CheckIcon from "../img/对号2.svg";
import RenameIcon from "../img/重命名.svg";
import CloseIcon from "../img/dialog_close.png";
import DeleteIcon from "../img/删除.svg";
import BackIcon from '../img/返回.svg'
import LogoutIcon from "../img/退出.png";
import PlayIcon from "../img/开始.png";
import TimeIcon from  "../img/时间.png";
import FailedIcon from "../img/cha.svg";
import OrderIcon from "../img/订单.png";
import AcornIcon from "../img/橡树果.png";
import AcornIcon2 from "../img/橡树果2.png";

import RightClickIcon from "../img/右键.png";
import VxIcon from "../img/vx.png";
import YxIcon from "../img/yx.png"
import Add from "./Add";
import { Menu, Popover } from "antd";
import api from "../api";
import bridge from "../jsBridge"
import {  pollModelStatus } from "../contact";
import { Cell,Toast, Dialog } from 'react-vant'
import PropTypesToastReturnType from 'prop-types';
import TaskPoller from "../utils/TaskPoller";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


/**
 * 首页组件
 * 展示舞蹈库管理界面，包括侧边栏导航和欢迎区域
 */
function Home() {
  const { t, i18n } = useTranslation();

  var [models, setModels] = React.useState([]);
    const navigate = useNavigate()

    const isNativeBridgeAvailable = () => {
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isDesktop = !isAndroid && !isIOS;
    
    console.log("环境检测:", { isAndroid, isIOS, isDesktop });
    
    // 如果是桌面环境，返回 true 允许继续（会走模拟流程）
    if (isDesktop) {
      return true;
    }
    
    if (isAndroid) {
      return !!(window.NativeBridge && window.NativeBridge.postMessage);
    }
    if (isIOS) {
      return !!(window.webkit?.messageHandlers?.nativeWithResult?.postMessage);
    }
    return false;
  };
  var [useLoadingToast, setUseLoadingToast] = React.useState(null);
  // 状态：存储当前北京时间
  var [currentTime, setCurrentTime] = React.useState("");

  // 状态：存储当前选中的导航项
  // 初始值为 'dance'，表示默认选中舞蹈库
  // 可选值：'dance'（舞蹈库）、'order'（订单）
  var [activeNav, setActiveNav] = React.useState("dance");

  // 状态：控制新建舞蹈项目表单的显示
  // 初始值为 false，表示默认不显示表单
  var [showCreateForm, setShowCreateForm] = React.useState(false);
  var showCreateFormRef = React.useRef(false);

  // 状态：存储当前选中的舞蹈项目
  // 初始值为 null，表示默认未选中任何舞蹈
  var [selectedDance, setSelectedDance] = React.useState(null);
  var selectedDanceRef = React.useRef(null);

  // 状态：存储当前是否正在重试
  // 初始值为 false，表示默认未在重试
  var [isRetrying, setIsRetrying] = React.useState(false);

  // 状态：存储重试进度
  var [retryProgress, setRetryProgress] = React.useState(0);

  // 状态：控制退款确认对话框的显示
  var [showRefundDialog, setShowRefundDialog] = React.useState(false);

  // 状态：跟踪正在生成的舞蹈项目
  var [generatingDanceId, setGeneratingDanceId] = React.useState(null);

  // 状态：跟踪退款状态
  var [refundStatus, setRefundStatus] = React.useState("confirm"); // confirm, submitted

  // 状态：控制部署到机器人的过程
  var [isDeploying, setIsDeploying] = React.useState(false);

  // 状态：控制确认启用对话框的显示
  var [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  // 状态：控制确认启用按钮loading，防止重复点击
  var [isEnabling, setIsEnabling] = React.useState(false);

  // 状态：控制加速过程
  var [boosting, setBoosting] = React.useState(false);
  var [boostProgress, setBoostProgress] = React.useState(0);

  // 状态：控制上下文菜单
  var [contextMenuVisible, setContextMenuVisible] = React.useState(false);
  var [contextMenuPosition, setContextMenuPosition] = React.useState({
    x: 0,
    y: 0,
  });
  var [currentDance, setCurrentDance] = React.useState(null);

  // 状态：控制删除确认对话框
  var [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  // 状态：控制退出登录确认弹框
  var [showLogoutDialog, setShowLogoutDialog] = React.useState(false);
  // 状态：防止重复点击退出
  var [isLoggingOut, setIsLoggingOut] = React.useState(false);
  // 状态：控制橡树果区域点击弹出的弹框
  var [showAcornDialog, setShowAcornDialog] = React.useState(false);
  // 状态：橡树果弹框模式（recharge=充值 / insufficient=余额不足）
  var [acornDialogMode, setAcornDialogMode] = React.useState("recharge");
  // 状态：橡树果可用余额
  var [acornBalance, setAcornBalance] = React.useState(null);
  // 状态：记录刚复制的字段（"wechat" / "email"），用于复制按钮变色反馈
  var [copiedField, setCopiedField] = React.useState(null);
  // 状态：橡树果弹框子视图（null=默认充值 / "rules"=使用规则 / "agreement"=充值服务协议）
  var [acornSubView, setAcornSubView] = React.useState(null);
  var isGeneratingStatus = (status) => {
    return (
      status === "生成中" ||
      status === "pending" ||
      status === "running" ||
      status === "PENDING" ||
      status === "RUNNING"
    );
  };





  // 状态：控制重命名对话框
  var [showRenameDialog, setShowRenameDialog] = React.useState(false);
  var [newDanceName, setNewDanceName] = React.useState("");
  var [taskInterval, setTaskInterval] = React.useState(0);
  var taskIntervalRef = React.useRef(null);
  var modelStatusPollerRef = React.useRef(null);

// ========== 新增：订单相关状态 ==========
  var [orders, setOrders] = React.useState([]);
  var [selectedOrder, setSelectedOrder] = React.useState(null);
  var [repayOrder, setRepayOrder] = React.useState(null);
  var [orderDetailLoading, setOrderDetailLoading] = React.useState(false);
  var [orderActionLoading, setOrderActionLoading] = React.useState(false);
  var [showOrderConfirmDialog, setShowOrderConfirmDialog] = React.useState(false);
  var [orderConfirmType, setOrderConfirmType] = React.useState(""); // cancel | delete





  // 点击页面其他地方关闭上下文菜单
  React.useEffect(() => {
    var handleClickOutside = (event) => {
      // 只有当上下文菜单显示时才处理
      if (contextMenuVisible) {
        // 检查点击事件是否发生在上下文菜单外部
        var contextMenuElement = document.querySelector(".context-menu");
        if (contextMenuElement && !contextMenuElement.contains(event.target)) {
          setContextMenuVisible(false);
        }
      }
    };

    // 添加点击事件监听器
    document.addEventListener("click", handleClickOutside);

    // 清理函数
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [contextMenuVisible]);
  const [safeAreaInfo, setSafeAreaInfo] = React.useState({ left: 0, right: 0 });
//安全距离


  React.useEffect(() => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      document.querySelector('.home-container')?.setAttribute('data-ios', 'true');
    }
  }, []);

  React.useEffect(() => {
    const updateSafeAreaInfo = () => {
      const root = document.documentElement;
      const left = getComputedStyle(root).getPropertyValue('--safe-area-left');
      const right = getComputedStyle(root).getPropertyValue('--safe-area-right');

      setSafeAreaInfo({
        left: parseInt(left) || 0,
        right: parseInt(right) || 0
      });
    };

    updateSafeAreaInfo();





    // 监听安全区域变化
    const observer = new MutationObserver(updateSafeAreaInfo);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });

    window.addEventListener('resize', updateSafeAreaInfo);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateSafeAreaInfo);
    };
  }, []);





  // 在现有的副作用代码附近添加
React.useEffect(() => {
  console.log("环境检测结果:", {
    userAgent: navigator.userAgent,
    isAndroid: /Android/i.test(navigator.userAgent),
    isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
    isDesktop: !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
    isNativeBridgeAvailable: isNativeBridgeAvailable()
  });
}, []);
React.useEffect(() => {
  showCreateFormRef.current = showCreateForm;
}, [showCreateForm]);
  // 状态：控制照相机效果和提示框
  var [showCameraEffect, setShowCameraEffect] = React.useState(false);
  var [showSimulationDialog, setShowSimulationDialog] = React.useState(false);

  // 状态：控制急停对话框
  // 不再需要状态，因为使用浏览器自带的confirm对话框
  // var [showEmergencyDialog, setShowEmergencyDialog] = React.useState(false);

  // 状态：控制舞蹈列表的显示与隐藏
  // true: 显示舞蹈列表（初始状态）
  // false: 隐藏舞蹈列表（点击舞蹈库按钮后）
  // var [showDanceList, setShowDanceList] = React.useState(true);

  // 状态：存储轮询定时器ID
  // var [pollingInterval, setPollingInterval] = React.useState(null);
var PAYMENT_UPDATE_TYPE = {
  DELETE: 0,
  CANCEL: 1,
};


  /**
   * 动态获取安全区顶部高度 (像素 px)
   * 适用于 iOS 刘海屏和部分 Android 挖孔屏
   */
  function getStatusBarHeight() {
    // 1. 创建一个隐藏的探测器
    const div = document.createElement('div');
    div.style.position = 'fixed';
    div.style.top = '0';
    div.style.visibility = 'hidden';

    // 2. 使用 env() 变量
    div.style.paddingTop = 'env(safe-area-inset-top)';

    document.body.appendChild(div);

    // 3. 读取计算后的像素值
    const style = window.getComputedStyle(div);
    const height = parseFloat(style.paddingTop);

    document.body.removeChild(div);
    return height || 0; // 如果返回 0，说明是非刘海屏或普通浏览器环境
  }


// 后端支付状态映射到页面订单状态：paid / pending / closed
var mapPaymentStatusToOrderStatus = (status) => {
  var statusNum = Number(status);
  if (statusNum === 1) {
    return "pending";
  }
  if (statusNum === 2 || statusNum === 5) {
    return "paid";
  }
  return "closed";
};

var mapPaymentToOrder = (payment) => {
  var safePayment = payment || {};
  var extra = safePayment.extra || {};
  var paymentOutId = String(
    safePayment.outId || safePayment.paymentOutId || "",
  );
  var finalPaymentStatus = Number(safePayment.status);
  return {
    id:
      paymentOutId ||
      extra.order_string ||
      `${safePayment.productId || "product"}-${safePayment.createDate || Date.now()}`,
    paymentOutId,
    orderNo: extra.order_string || safePayment.outId || "-",
    danceName: safePayment.assignmentName || safePayment.productName || "-",
    amount: Number(safePayment.payAmount || 0),
    productId: safePayment.productId || "",
    productName: safePayment.productName || "",
    paymentStatus: finalPaymentStatus,
    status: mapPaymentStatusToOrderStatus(finalPaymentStatus),
    createdAt: safePayment.createDate || "",
  };
};

var fetchOrders = async () => {
  try {
    var response = await api.login.get("/payment/list", {
      offset: 0,
      limit: 20,
      paymentStatus: -1,
    });
    var payments = Array.isArray(response?.payments) ? response.payments : [];
    var normalizedOrders = payments.map((payment) => mapPaymentToOrder(payment));
    setOrders(normalizedOrders);
  } catch (error) {
    console.error("fetchOrders:failed", error);
    setOrders([]);
    Toast.fail(t('order.loadFailed'));
  }
};

var normalizePaymentDetailResponse = (response) => {   
  if (!response || typeof response !== "object") {
    return null;
  }
  if (response.outId || response.paymentOutId) {
    return response;
  }
  if (response.data && (response.data.outId || response.data.paymentOutId)) {
    return response.data;
  }
  if (
    response.data &&
    response.data.data &&
    (response.data.data.outId || response.data.data.paymentOutId)
  ) {
    return response.data.data;
  }
  return null;
};

var fetchOrderDetail = async (paymentOutId) => {
  var normalizedOutId = String(paymentOutId || "").trim();
  if (!normalizedOutId) {
    return null;
  }
  var response = await api.login.get(
    `/payment/query/${encodeURIComponent(normalizedOutId)}`,
  );
  return normalizePaymentDetailResponse(response);
};

var handleOrderSelect = async (order) => {
  if (!order) {
    return;
  }
  setShowCreateForm(false);
  setSelectedOrder(order);

  var paymentOutId = String(order.paymentOutId || order.id || "").trim();
  if (!paymentOutId) {
    return;
  }

  try {
    setOrderDetailLoading(true);
    var detailPayment = await fetchOrderDetail(paymentOutId);
    if (!detailPayment) {
      return;
    }
    var detailOrder = mapPaymentToOrder(detailPayment);
    setSelectedOrder(detailOrder);
    setOrders((prevOrders) =>
      prevOrders.map((item) =>
        item.paymentOutId === detailOrder.paymentOutId ? detailOrder : item,
      ),
    );
  } catch (error) {
    console.error("fetchOrderDetail:failed", error);
    Toast.fail(t('order.detailLoadFailed'));
  } finally {
    setOrderDetailLoading(false);
  }
};

// 统一订单状态，页面只使用：paid / pending / closed
var normalizeOrderStatus = (status) => {
  var normalizedNum = Number(status);
  if (status === "paid" || status === "completed" || normalizedNum === 2 || normalizedNum === 5) {
    return "paid";
  }
  if (status === "pending" || status === "unpaid" || normalizedNum === 1) {
    return "pending";
  }
  if (
    status === "closed" ||
    status === "refunded" ||
    normalizedNum === 0 ||
    normalizedNum === 3 ||
    normalizedNum === 4 ||
    normalizedNum === 6 ||
    normalizedNum === 7 ||
    normalizedNum === 8 ||
    normalizedNum === 9 ||
    normalizedNum === -1
  ) {
    return "closed";
  }
  return "closed";
};

var getOrderStatusText = (status) => {
  var normalizedStatus = normalizeOrderStatus(status);
  if (normalizedStatus === "paid") {
    return t('order.paid');
  }
  if (normalizedStatus === "pending") {
    return t('order.pending');
  }
  return t('order.closed');
};

var openOrderConfirmDialog = (type) => {
  setOrderConfirmType(type);
  setShowOrderConfirmDialog(true);
};

var handleGoPay = () => {
  if (!selectedOrder) {
    return;
  }
  setRepayOrder(selectedOrder);
  setShowCreateForm(true);
};

var clearRepayOrder = () => {
  setRepayOrder(null);
};

var handleRepayExit = () => {
  setShowCreateForm(false);
  clearRepayOrder();
  fetchOrders();
};

var closeOrderConfirmDialog = () => {
  setShowOrderConfirmDialog(false);
  setOrderConfirmType("");
};

var updatePayment = async (paymentOutId, updateType) => {
  return await api.login.post("/payment/update", {
    paymentOutId: paymentOutId,
    type: updateType,
  });
};

var handleOrderConfirm = async () => {
  if (!selectedOrder?.paymentOutId || orderActionLoading) {
    return;
  }

  var paymentOutId = String(selectedOrder.paymentOutId).trim();
  var isDelete = orderConfirmType === "delete";
  var updateType = isDelete ? PAYMENT_UPDATE_TYPE.DELETE : PAYMENT_UPDATE_TYPE.CANCEL;

  try {
    setOrderActionLoading(true);
    await updatePayment(paymentOutId, updateType);
    Toast.success(isDelete ? t('order.deleted') : t('order.cancelled'));
    closeOrderConfirmDialog();
    await fetchOrders();
    if (isDelete) {
      setSelectedOrder(null);
    } else {
      var latestDetailPayment = await fetchOrderDetail(paymentOutId);
      if (latestDetailPayment) {
        var latestDetailOrder = mapPaymentToOrder(latestDetailPayment);
        setSelectedOrder(latestDetailOrder);
      }
    }
  } catch (error) {
    console.error("updatePayment:failed", error);
    Toast.fail(t('order.operationFailed'));
  } finally {
    setOrderActionLoading(false);
  }
};

// 副作用：组件挂载时获取任务列表（与当前登录用户绑定，登录后页面重载即可）
React.useEffect(() => {
  console.log("Home component mounted, fetching tasks...");
  // 调用 fetchTasks 函数获取任务列表
  getStatusBarHeight()
  getModelList()
  fetchAcornBalance()

  fetchTasks({ reset: true });
}, []);

// 新增：订单数据加载
React.useEffect(() => {
  if (activeNav === "order") {
    console.log("切换到订单页面，加载订单数据...");
    fetchOrders();
  }
}, [activeNav]);


  // 状态：存储任务列表
  var [dances, setDances] = React.useState([]);
  var PAGE_LIMIT = 20;
  var [taskPage, setTaskPage] = React.useState(1);
  var [taskHasMore, setTaskHasMore] = React.useState(true);
  var [taskLoadingMore, setTaskLoadingMore] = React.useState(false);
  // 副作用：当开始重试时，启动进度增加定时器

  // 获取任务进度
  var getTaskProgress = async (taskId) => {
    if (!taskId) {
      return null;
    }
    try {
      const response = await api.get(`/api/v1/task/${taskId}`, {
        origin_type: "user",
        
      });
      return response;
    } catch (error) {
      console.error("getTaskProgress:failed " + error.message);
      return null;
    }
  };

  // 删除任务
  var deleteTask = async (taskId) => {
    if (!taskId) {
      return;
    }
    try {
      const response = await api.delete(`/api/v1/task/${taskId}`);
      console.log("deleteTask:success", response);
      // 删除成功后，从舞蹈列表中移除对应的任务
      setDances((prevDances) => prevDances.filter((dance) => dance.taskId !== taskId));
      // 如果删除的是当前选中的舞蹈，清除选中状态
      if (selectedDance && selectedDance.taskId === taskId) {
        setSelectedDance(null);
        selectedDanceRef.current = null;
      }
      return response;
    } catch (error) {
      console.error("deleteTask:failed " + error.message);
      return null;
    }
  };

  // 1. 模拟一个网络请求函数
const checkStatus = (modelId) => {
  return new Promise((resolve, reject) => {
    bridge.sendMessageToAgent({
      command: "getModelStatus",
      data: {
        model_id: modelId,
      },
    }).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
      })
  });
};

// 2. 实例化工具类 (每1秒一次，总共20秒)
const poller = new TaskPoller(checkStatus, 1000, 20000);



  /**
   * 根据模型id 
   * @param {*} modelId 
   */
  const getModelUrl = async (modelId, taskName, cover_url, duration, mediaId) => {
    try {
      // // 显示全屏加载 Toast
      // setUseLoadingToast(Toast.info({
      //   message: '启用中...',
      //   // duration: 0,
      //   // forbidClick: true,
      // }));

      console.log("开始下载模型:", { modelId, taskName });

      // ✅ 添加固定延迟，让 loading 显示更长时间
      console.log("模拟加载过程，请等待...");
      await new Promise(resolve => setTimeout(resolve, 3000)); // 3秒延迟

      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      // ✅ 如果是测试环境，可以再增加延迟
      if (!isMobile || process.env.NODE_ENV === 'development') {
        console.log("测试环境，延长加载时间");
        await new Promise(resolve => setTimeout(resolve, 2000)); // 再加2秒
      }

      const res = await api.get(`/api/v1/model/${modelId}/download`);
      console.log("getModelUrl API 响应:", res);

      // 取音频下载地址（源视频 audio），music_url 传给 Native；音频必须，失败则中断启用
      const audio = await api.getMediaDownloadUrl(mediaId, "audio");
      const audioUrl = audio?.download_url;
      if (!audioUrl) {
        throw new Error("获取音频下载地址失败");
      }
      console.log("getMediaDownloadUrl:audio", audio);

      // ✅ 在桥接调用前也加一点延迟
      await new Promise(resolve => setTimeout(resolve, 1000));

      const downloadResp = await bridge.sendMessageToAgent({
        command: "downloadModel",
        data: {
          dance_name: taskName,
          cover_url: cover_url,
          model_id: modelId,
          url: res.download_url,
          duration_ms:duration*1000,
          music_url:audioUrl,
        },
      });

      console.log("downloadModel 响应:", downloadResp);

      // ✅ 增加轮询前的延迟
      await new Promise(resolve => setTimeout(resolve, 1500));

      // 启动轮询
      modelStatusPollerRef.current?.stop?.();
      const poller = new TaskPoller(checkStatus, 1000, 20000);
      modelStatusPollerRef.current = poller;
      poller.start(modelId).then((finalData) => {
        Toast.success(t('danceLibrary.enableSuccess'));
        setShowConfirmDialog(false);
        setUseLoadingToast(null);
        modelStatusPollerRef.current = null;
        getModelList()
      }).catch((err) => {
        console.error("轮询失败:", err);
        Toast.info(t('danceLibrary.enableFailed'));
        setUseLoadingToast(null);
        modelStatusPollerRef.current = null;
      });

    } catch (error) {
      console.error("getModelUrl 失败:", error);
      Toast.info(t('danceLibrary.enableFailedWithMsg', { message: error.message || t('danceLibrary.pleaseRetry') }));
      setUseLoadingToast(null);
    }
  };


  //获取已安装模型列表
   const  getModelList=async()=>{
     console.log("调用 bridge.sendMessageToAgent...");
     const response = await bridge.sendMessageToAgent({
       command: "listModel",
       data: { user_id: localStorage.getItem("user_id") }
     });

     console.log("listModel response:", response);

     if (response && response.success === false) {
       console.log("listModel failed:", response.message);
       Toast.info(t('danceLibrary.getModelListFailed', { message: response.message || t('danceLibrary.unknownError') }));
       return;
     }

     setModels(response?.data?.models || []);
  }

  // 查询橡树果余额
  var fetchAcornBalance = async () => {
    try {
      const res = await api.getAcornBalance();
      const raw = res?.availableAmount;
      // 只有拿到有效数字才算数；空值/异常值按"未知(null)"处理，避免和真实余额 0 混淆
      const parsed = raw == null ? NaN : Number(raw);
      setAcornBalance(Number.isFinite(parsed) ? parsed : null);
    } catch (error) {
      console.error("fetchAcornBalance:failed", error);
      // 拉取失败保持 null（未知），不误判为余额 0
      setAcornBalance(null);
    }
  };

  // 获取任务列表（支持重置和触底分页加载）
  var fetchTasks = async ({ reset = false } = {}) => {
    if (taskLoadingMore) {
      console.log("fetchTasks:loading more data");
      return;
    }
    if (!reset && !taskHasMore) {
      console.log("fetchTasks:no more data");
      return;
    }

    const currentPage = reset ? 1 : taskPage;
    const offset = (currentPage - 1) * PAGE_LIMIT;
    setTaskLoadingMore(true);
    try {
      const response = await api.get(`/api/v1/task`, {
        limit: PAGE_LIMIT,
        offset,
        origin_type: "user",
        user_id: localStorage.getItem("user_id"),
      });
      console.log("fetchTasks:success raw", response);
      try {
        console.log(
          "fetchTasks:success raw json",
          JSON.stringify(response),
        );
      } catch (e) {
        // ignore JSON stringify errors
      }
      // 兼容不同返回结构：{ items } / { tasks } / { data: { items } }
      const items =
        response?.items ??
        response?.tasks ??
        response?.data?.items ??
        response?.data?.tasks ??
        [];

      // 兼容 has_more 字段；如果没有，则用返回条数推断
      let hasMore = response?.has_more;
      if (typeof hasMore !== "boolean") {
        hasMore = Array.isArray(items) && items.length === PAGE_LIMIT;
      }

      setTaskHasMore(hasMore);
      if (hasMore) {
        let nextPage = currentPage + 1;
        setTaskPage(nextPage);
        console.log("fetchTasks:has more data", nextPage);
      } else {
        setTaskPage(1);
      }
      console.log("fetchTasks:items", items, {
        hasItems: Array.isArray(items),
      });

      if (Array.isArray(items)) {
        // 将任务列表转换为舞蹈列表格式
        const tasks = items.map((task) => ({
          id: task.task_id,
          name: task.task_name,
          status: task.status,
          statusClass:task.status,
          model: task.robot_model,
          progress: task.progress,
          coviwrUrl: task.cover_url,
          taskId: task.task_id,
          model_id: task.model_id,
          task_name: task.task_name,
          cover_url: task.cover_url,
          media_id: task.media_id,
           // 添加开始时间和视频时长字段
        start_time: task.created_timestamp, // 使用start_time或created_at
        video_duration: task.duration || 0, // 视频时长，单位秒
        }));
        setDances((prevDances) => (reset ? tasks : [...prevDances, ...tasks]));

        if (reset && tasks.length > 0) {
          let task = tasks[0];
          setSelectedDance(task)
          selectedDance = task;
          selectedDanceRef.current = task;
          showCreateFormRef.current = false;
          setShowCreateForm(false);
          stopTaskPolling();
          console.log("clear taskInterval");
          if((selectedDanceRef.current.status==="running" || selectedDanceRef.current.status === "pending") && selectedDanceRef.current !=null){
          // 后续从状态获取
            startTaskPolling();
            console.log("start taskInterval", taskIntervalRef.current,selectedDanceRef.current);
          }else{
            console.log(`任务 ${selectedDanceRef.current.id} 状态为 ${selectedDanceRef.current.status}，不启动轮询`);
          }
        } else if (reset && tasks.length === 0) {
          setSelectedDance(null);
          selectedDanceRef.current = null;
          stopTaskPolling();
        }
      }
    } catch (error) {
      console.error("fetchTasks:failed ", error?.message, {
        response: error?.response?.data,
        status: error?.response?.status,
      });
    } finally {
      setTaskLoadingMore(false);
    }
  };

  // 请求重命名接口
  const requestRenameTask = (taskId,name) =>{
    try {
      const response = api.patch(`/api/v1/task/${taskId}`, { task_name: name.trim() });
      response.then((res) =>{
        //刷新列表
        fetchTasks({ reset: true });
      }).catch((err) =>{})
    } catch (error) {
      console.error("getTaskProgress:failed " + error.message);
      return null;
    }
  }

  // 轮询函数 - 使用 ref 获取最新选中的舞蹈，确保闭包中始终是最新值
  const pollSelectedTask = () => {
    // 添加页展示时不轮询，避免切到创建页后旧任务继续请求
    if (showCreateFormRef.current) {
      return;
    }
    const currentDance = selectedDanceRef.current;
    if (currentDance) {
      console.log(`轮询任务: ${currentDance.taskId}`);
      const taskData = getTaskProgress(currentDance.taskId);
      taskData.then((res)=>{
        if (res) {
          console.log(`轮训结果:当前进度: ${res.progress}, 状态: ${res.status}`);
          setRetryProgress(res.progress);
          if(res.status == "success"){
            if (taskIntervalRef.current) {
              clearInterval(taskIntervalRef.current);
              taskIntervalRef.current = null;
            }
          }
        }
      }).catch((err)=>{
        console.log(`轮询结果:`, err);
      })
    }else{
      console.log(`没有选中的舞蹈，无法轮询`);
    }
  };

  // 处理图片点击事件
  var handleImageClick = () => {
    // 保留点击入口，其他逻辑不变；不再触发相机动画效果
  };

  var formatDateTime = (dateStr)=> {
  const date = new Date(dateStr);

  // 获取各部分数值
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

  // 处理生成新舞蹈项目
  var handleGenerate = (danceData) => {
    // 创建新的舞蹈项目对象
    var newDance = {
      ...danceData,
      status: danceData.status || "生成中",
      statusClass: "generating",
      progress: danceData.progress || 0,

      start_time: danceData.created_timestamp|| "",
      video_duration: danceData.duration || 0,

    };

    fetchTasks({ reset: true })
    // 生成后立即刷新橡树果余额，避免侧边栏显示的是挂载时的旧值
    fetchAcornBalance()
    // 隐藏舞蹈列表，确保新生成的舞蹈项目在第一张图片上显示
    // setShowDanceList(false);
  };

  // 点击页面其他地方关闭上下文菜单
React.useEffect(() => {
  var handleClickOutside = (event) => {
    // 只有当上下文菜单显示时才处理
    if (contextMenuVisible) {
      // 检查点击事件是否发生在上下文菜单外部
      var contextMenuElement = document.querySelector(".context-menu");
      if (contextMenuElement && !contextMenuElement.contains(event.target)) {
        setContextMenuVisible(false);
      }
    }
  };

  // 滚动时关闭上下文菜单
  var handleScroll = (event) => {
    if (contextMenuVisible) {
      setContextMenuVisible(false);
    }
    if (activeNav !== "dance" || taskLoadingMore || !taskHasMore) {
      return;
    }
    const target = event?.target || document.querySelector(".dance-list");
    if (!target) {
      return;
    }
    const reachedBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 40;
    if (reachedBottom) {
      fetchTasks({ reset: false });
    }
  };

  // 添加点击事件监听器
  document.addEventListener("click", handleClickOutside);

  // 添加滚动事件监听器（使用 passive 优化性能）
  const scrollContainer = document.querySelector(".dance-list");
  if (scrollContainer) {
    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
  }

  // 清理函数
  return () => {
    document.removeEventListener("click", handleClickOutside);
    if (scrollContainer) {
      scrollContainer.removeEventListener("scroll", handleScroll);
    }
  };
}, [contextMenuVisible, activeNav, taskLoadingMore, taskHasMore, taskPage]);

  // 副作用：组件挂载时启动定时器，每分钟更新一次时间
  React.useEffect(() => {
    /**
     * 更新当前时间
     * 获取当前时间并转换为北京时间（UTC+8）
     */
    var updateTime = () => {
      // 获取当前UTC时间
      var now = new Date();
      // 计算北京时间（UTC + 8小时）
      var utcHour = now.getUTCHours();
      var utcMinute = now.getUTCMinutes();

      // 计算北京时间的小时和分钟
      var beijingHour = utcHour + 8;
      var beijingMinute = utcMinute;

      // 处理跨天的情况
      if (beijingHour >= 24) {
        beijingHour -= 24;
      }

      // 格式化小时和分钟，保持两位数
      var hours = beijingHour.toString().padStart(2, "0");
      var minutes = beijingMinute.toString().padStart(2, "0");

      // 更新状态
      setCurrentTime(`${hours}:${minutes}`);
    };

    // 立即更新一次时间
    updateTime();
    // 设置定时器，每隔60秒更新一次时间
    var interval = setInterval(updateTime, 60000);
    // 组件卸载时清除定时器，防止内存泄漏
    return () => clearInterval(interval);
  }, []);

  const stopTaskPolling = () => {
    if(taskIntervalRef.current){
      console.log("clear taskIntervalRef:", taskIntervalRef.current);
      clearInterval(taskIntervalRef.current);
      taskIntervalRef.current = null;
    }
    if (modelStatusPollerRef.current) {
      modelStatusPollerRef.current.stop();
      modelStatusPollerRef.current = null;
    }
  };

  const startTaskPolling = () => {
    stopTaskPolling();
    taskIntervalRef.current = setInterval(() => {
      pollSelectedTask();
    }, 1000);
  };

  React.useEffect(() => {
    return () => {
      stopTaskPolling();
    };
  }, []);

  const handleLogout = () => {
    //取消轮训任务
    stopTaskPolling();
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_id");
    navigate('/login');
  };

  const openLogoutDialog = () => {
    if (isLoggingOut) {
      return;
    }
    setShowLogoutDialog(true);
  };

  const closeLogoutDialog = () => {
    if (isLoggingOut) {
      return;
    }
    setShowLogoutDialog(false);
  };

  const confirmLogout = () => {
    if (isLoggingOut) {
      return;
    }
    setIsLoggingOut(true);
    try {
      handleLogout();
    } finally {
      // navigate 后组件可能会卸载，这里设置状态即使不执行也无碍
      setIsLoggingOut(false);
      setShowLogoutDialog(false);
    }
  };

  // 复制文本到剪贴板，并给对应按钮变色反馈
  const copyToClipboard = (text, field) => {
    const done = () => {
      setCopiedField(field);
      // Toast.success("复制成功");
      setTimeout(() => setCopiedField(null), 2000);
    };

    const fallback = () => {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        done();
      } catch (e) {
        console.error("复制失败", e);
      }
      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(fallback);
    } else {
      fallback();
    }
  };

  return (
    // 主容器
    <div className="home-container">
      {/* 调试信息 */}
      <div style={{
        position: 'fixed',
        top: 10,
        right: 10,
     
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '12px', 
        zIndex: 9999
      }}>
     
        {/* <div style={{ fontSize: '10px', opacity: 0.7 }}>
          {/Android/.test(navigator.userAgent) ? '安卓' : 'iOS'} ·
          {window.matchMedia('(orientation: landscape)').matches ? '横屏' : '竖屏'}
        </div> */}
      </div>
      {/* 头部区域：显示时间和状态栏 */}
      <div className="header">
        {/* 显示当前北京时间 */}
        <div className="time">{currentTime}</div>
        {/* 状态栏图标 */}
        <div className="status-bar"></div>
      </div>

      {/* 主内容区域：包含侧边栏和右侧内容 */}
      <div className="main-content">
        {/* 侧边栏：导航和舞蹈列表 */}
        <div className="sidebar">
          {/* 侧边栏头部：使用原生 React 实现导航切换 */}
          <div className="sidebar-header">
            {/* 返回按钮（Native close） */}
            <div
              className="back-icon"
              onClick={(e) => {
                e.stopPropagation();
                // 非 Native 环境也不要强行调用，避免抛出“非 Native 环境”异常
                const canCallAndroid =
                  window.NativeBridge && window.NativeBridge.postMessage;
                const canCallIOS =
                  window.webkit?.messageHandlers?.nativeWithResult?.postMessage;

                if (canCallAndroid || canCallIOS) {
                  bridge.close().catch(() => {
                    // 静默兜底：避免控制台报错影响正常使用
                  });
                } else {
                  // 纯网页环境：尝试返回上一级；没有历史则不做事
                  if (window.history && window.history.length > 1) {
                    window.history.back();
                  }
                }
              }}
            >
              <img src={BackIcon} width={24} height={24} alt={t('common.back')} />
            </div>


            {/* 导航项容器 */}
            <div className="nav-container">
            {/*  /!* 舞蹈库导航项 *!/*/}
             <div
           className={`nav-item ${activeNav === "dance" ? "active" : ""}`}
                onClick={() => {
               // 切换到舞蹈库导航
                setActiveNav("dance");
                clearRepayOrder();
                // 清除选中的舞蹈项目，确保从其他页面返回时显示欢迎页面
              setSelectedDance(null);
               selectedDanceRef.current = null;
             }}
             >
              {t('danceLibrary.title')}
           </div>

        {/*订单导航项先隐藏（代码保留，按需恢复）*/}
              <div
                className={`nav-item ${activeNav === "order" ? "active" : ""}`}
                style={{ display: "none" }}
                onClick={() => {
                  setActiveNav("order");
                  clearRepayOrder();
                  setSelectedOrder(null);
                  setSelectedDance(null);
                  // 切到订单时关闭上传表单，避免右侧仍渲染上传页
                  setShowCreateForm(false);
                  // 切换到订单时，可以在这里加载订单数据
                }}
              >
                {t('danceLibrary.order')}
              </div>




            </div>
            {/* 添加按钮：点击显示新建舞蹈项目表单，仅在舞蹈库/订单页面显示 */}
            {(activeNav === "dance" || activeNav === "order") && (
              <div
                className="add-button"
                onClick={() => {
                  stopTaskPolling();
                  clearRepayOrder();
                  setSelectedDance(null);
                  selectedDanceRef.current = null;
                  showCreateFormRef.current = true;
                  setShowCreateForm(true);
                }}
              >
                +
              </div>
            )}
          </div>

          {/* 内容区域：根据选中的导航项显示不同内容 */}
          <div className="content-area">
            {/* 当选中舞蹈库且显示舞蹈列表时，显示所有数据，包括生成中的数据 */}
            {activeNav === "dance" && (
              <div className="dance-list">
                {dances.length > 0 ? (
                  dances.map((dance) => (
                    <div
                      key={dance.id}
                      className={`dance-item ${selectedDance && selectedDance.id === dance.id ? 'selected' : ''}`}
                      onTouchStart={(e) => {
                        e.currentTarget.dataset.touchStart = Date.now();
                      }}
                      onTouchEnd={(e) => {
                        const touchDuration = Date.now() - parseInt(e.currentTarget.dataset.touchStart || '0');
                        if (touchDuration >= 500) {
                          e.preventDefault();
                          e.stopPropagation();
                          setSelectedDance(dance);
                          if (window.getSelection) {
                            window.getSelection().removeAllRanges();
                          } else if (document.selection) {
                            document.selection.empty();
                          }
                          selectedDance = dance;
                          selectedDanceRef.current = dance;
                          console.log("Selected dance onLongPress:", dance);
                          setCurrentDance(dance);
                          const touch = e.changedTouches[0];
                          setContextMenuPosition({
                            x: touch.clientX,
                            y: touch.clientY,
                          });
                          setContextMenuVisible(true);
                        }
                      }}
                      onClick={() => {
                        setSelectedDance(dance);
                        selectedDance = dance;
                        selectedDanceRef.current = dance;
                        showCreateFormRef.current = false;
                        setShowCreateForm(false);
                        stopTaskPolling();
                        console.log("clear taskInterval");
                        if((selectedDanceRef.current.status==="running" || selectedDanceRef.current.status === "pending") && selectedDanceRef.current != null){
                          startTaskPolling();
                          console.log("start taskInterval", taskIntervalRef.current,selectedDanceRef.current.id);
                        }else{
                          console.log(`任务 ${selectedDanceRef.current.id} 状态为 ${selectedDanceRef.current.status}，不启动轮询`);
                        }
                      }}
                      onContextMenu={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setSelectedDance(dance);
                        // 清除文字选中
                        if (window.getSelection) {
                          window.getSelection().removeAllRanges();
                        } else if (document.selection) {
                          document.selection.empty();
                        }
                        selectedDance = dance;
                        selectedDanceRef.current = dance;
                        console.log("Selected dance onContextMenu :", dance);
                        setCurrentDance(dance);
                        setContextMenuPosition({
                          x: event.clientX,
                          y: event.clientY,
                        });
                        setContextMenuVisible(true);
                      }}
                    >
                      {/* 舞蹈图标 */}
                      <div
                        className="dance-icon"
                        style={{
                          ...(dance.cover_url && {
                            backgroundImage: `url(${dance.cover_url})`,
                          }),
                        }}
                      ></div>
                      {/* 舞蹈信息 */}
                      <div className="dance-info">
                        <div className="dance-name">
                          {dance.name}
                          {isRetrying &&
                            selectedDance &&
                            selectedDance.id === dance.id &&
                            " 🔄"}
                        </div>
                        <div
                          className={`dance-status ${isRetrying && selectedDance && selectedDance.id === dance.id ? "success" : dance.status === "pending" || dance.status === "running" ? "generating" : dance.statusClass}`}
                        >
                          {isRetrying &&
                          selectedDance &&
                          selectedDance.id === dance.id
                            ? t('danceLibrary.statusGenerating')
                            : dance.status === "pending"
                              ? t('danceLibrary.statusQueuing'):
                                dance.status === "running"
                              ? t('danceLibrary.statusGenerating')
                              : dance.status === "success"
                                ? t('danceLibrary.statusCompleted')
                                  : dance.status === "failed"
                                  ? t('danceLibrary.statusGenerationFailed')
                                : dance.status}
                        </div>
                      </div>
                      {/* 删除按钮 */}
                      {/* <button
                        className="delete-button"
                        onClick={(event) => {
                          event.stopPropagation();
                          if (window.confirm('确定要删除这个任务吗？')) {
                            deleteTask(dance.taskId);
                          }
                        }}
                      >
                        ×
                      </button> */}
                    </div>
                  ))
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon"></div>
                    <div className="empty-text">{t('danceLibrary.empty')}</div>
                  </div>
                )}
              </div>
            )}

            {activeNav === "order" && (
              <div className="dance-list">
                {orders.length === 0 ? (
                  <div className="empty-orders">{t('order.empty')}</div>
                ) : (
                  orders.map((order) => (
                    <div
                      key={order.id}
                      className="dance-item"
                      onClick={() => handleOrderSelect(order)}
                      style={{
                        backgroundColor:
                          selectedOrder &&
                          selectedOrder.paymentOutId === order.paymentOutId
                            ? "#f5f5f5"
                            : undefined,
                      }}
                    >
                      <div
                        className="dance-icon"
                        style={{
                          backgroundImage: `url(${OrderIcon})`,
                        }}
                      ></div>

                      <div className="dance-info">
                        <div className="dance-name">{order.danceName}</div>
                        <div
                          className={`dance-status order-list-status ${
                            normalizeOrderStatus(order.status) === "closed"
                              ? "failed"
                              : normalizeOrderStatus(order.status) === "paid"
                                ? "completed"
                                : "pending"
                          }`}
                        >
                          {getOrderStatusText(order.status)}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
          <div className="sidebar-logout">
            <div
              className="sidebar-logout-decor"
              onClick={() => {
                setAcornDialogMode("recharge");
                setShowAcornDialog(true);
              }}
            >
              <img
                src={AcornIcon}
                alt={t('common.acorn')}
                className="sidebar-acorn-icon"
                width={12}
                height={22}
              />
             
              {/* 橡树果后面的数字：显示可用余额 */}
              <span className="sidebar-acorn-count">
                {acornBalance ?? ""}
              </span>
               <img
                src={RightClickIcon}
                alt={t('danceLibrary.rightClick')}
                className="sidebar-rightclick-icon"
                width={4}
                height={7}
              />
            </div>
            <div className="sidebar-logout-btn" onClick={openLogoutDialog}>
              <img
                src={LogoutIcon}
                alt={t('danceLibrary.logout')}
                className="sidebar-logout-icon"
                width={9}
                height={10}
              />
              <span className="sidebar-logout-text">{t('danceLibrary.logout')}</span>
            </div>
          </div>
        </div>

        {/* 右侧内容区域：根据状态显示不同内容 */}
        <div className="content">
          {showCreateForm ? (
            /* 当显示创建表单时 */
            <Add
              onGenerate={handleGenerate}
              repayOrder={repayOrder}
              onRepayExit={handleRepayExit}
              onOpenAcornDialog={() => {
                setAcornDialogMode("insufficient");
                setShowAcornDialog(true);
              }}
            />
          ) : selectedDance ? (
            /* 当选中舞蹈项目时，显示舞蹈详情页面 */
            <div className="dance-detail">
              {/* 当部署到机器人时，只显示部署到机器人的内容 */}
              {isDeploying ? (
                <div className="deploy-to-robot">
                  <div className="deploy-header">
                    <button
                      className="back-button"
                      onClick={() => setIsDeploying(false)}
                    >
                      <span className="back-symbol">&lt;</span>
                    </button>
                    <h3 className="deploy-title">{t('deploy.title')}</h3>
                  </div>
                  <div className="deploy-info">
                    <div className="deploy-info-item">
                      <span className="deploy-info-label">{t('deploy.project')}</span>
                      <span className="deploy-info-value">
                        {selectedDance.name}
                      </span>
                    </div>
                    <div className="deploy-info-item">
                      <span className="deploy-info-label">{t('deploy.model')}</span>
                      <span className="deploy-info-value">
                        {selectedDance.model}
                      </span>
                    </div>
                    <div className="deploy-info-item">
                      <span className="deploy-info-label">{t('deploy.targetRobot')}</span>
                      <span className="deploy-info-value robot-info">
                        <span className="robot-icon"></span>
                        ROBOT-001 (模拟)
                      </span>
                    </div>
                  </div>
                  <button
                    className="action-button deploy-confirm"
                    onClick={() => {
                      // 关闭部署界面
                      setIsDeploying(false);
                      // 更新舞蹈状态为已部署
                      const updatedDance = {
                        ...selectedDance,
                        status: "已部署",
                        statusClass: "deployed",
                      };
                      // 更新选中的舞蹈状态
                      setSelectedDance(updatedDance);
      selectedDanceRef.current = updatedDance;
                      console.log("Deploying dance:", updatedDance);
                      // 更新舞蹈列表中的状态
                      setDances((prevDances) =>
                        prevDances.map((dance) =>
                          dance.id === selectedDance.id ? updatedDance : dance,
                        ),
                      );
                    }}
                  >
                    {t('deploy.confirm')}
                  </button>
                </div>
              ) : (
                /* 正常显示舞蹈详情 */
                <>
                  {/* 舞蹈详情头部：图片和基本信息 */}
                  <div className="dance-detail-header">
                    {/* 舞蹈图片 */}
                    <div
                      className="dance-image"
                      style={{
                        backgroundImage:
                          selectedDance && selectedDance.cover_url
                            ? `url(${selectedDance.cover_url})`
                            : "url(./img/霍元甲舞姿.png)",
                        transform: "none",
                      }}
                    >
                    </div>
                    {/* 舞蹈信息 */}
                    <div className="dance-detail-info">
                      <h3 className="dance-detail-name">
                        {selectedDance.name}
                      
                      </h3>
                       <div className="dance-detail-start-time">{t('danceLibrary.uploadTime')}: {formatDateTime(selectedDance.start_time)}</div>
                       <div className="dance-detail-time">{t('danceLibrary.duration')}: {selectedDance.video_duration}s</div>
                      <div className="dance-detail-model">
                        {t('danceLibrary.modelLabel')}: {selectedDance.model}
                      </div>
                      <div className="dance-detail-status-slot">
                        {/* 重试状态显示 */}
                        {isRetrying ? (
                          <div className="retry-status">
                            <div className="retry-progress-text">
                              {/* <span className="retry-icon">⏱️</span> */}
                              <img className="retry-icon" src={TimeIcon} alt={t('common.time')} width="16" height="16" />
                              {t('danceLibrary.progressGenerating', { percent: Math.floor(retryProgress * 100) })}
                            </div>
                            <div className="progress-bar">
                              <div
                                className="progress-fill"
                                style={{ width: `${retryProgress}%` }}
                              ></div>
                            </div>
                          </div>
                        ) :

                          selectedDance.status === "pending" ? (
                          <div className="retry-status">
                            <div className="retry-progress-text">
                              <img className="retry-icon" src={TimeIcon} alt={t('common.time')} width="16" height="16" />
                              {t('danceLibrary.progressQueuing')}
                            </div>
                          </div>
                        ) : selectedDance.status === "running" ? (
                          <div className="retry-status">
                            <div className="retry-progress-text">
                              <img className="retry-icon" src={TimeIcon} alt={t('common.time')} width="16" height="16" />
                              {t('danceLibrary.progressGenerating', { percent: Math.round(selectedDance.progress * 100) })}
                            </div>
                            <div className="progress-bar">
                              <div
                                className="progress-fill"
                                style={{ width: `${Math.round(selectedDance.progress * 100)}%` }}
                              ></div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="dance-detail-status-item retry-progress-text"
                             style={{
                                transition: "none",
                                color:
                                  selectedDance.status === "success" ||
                                  selectedDance.status === "SUCCESS" ||
                                  selectedDance.status === "completed" ||
                                  selectedDance.status === "已完成"
                                    ? "#12B981"
                                    : selectedDance.status === "pending" ||
                                      selectedDance.status === "running" ||
                                      selectedDance.status === "PENDING" ||
                                      selectedDance.status === "RUNNING" ||
                                      selectedDance.status === "生成中"
                                    ? "#2663EB"
                                    : selectedDance.status === "failed"
                                    ? "#EF4444"
                                    : "#666",
                              }}>
                              <span
                                className={`status-icon ${selectedDance.statusClass}`}
                              >
                                {(selectedDance.statusClass === "success") && (
                                  <img
                                    src={CheckIcon}
                                    alt={t('common.check')}
                                    width="18"
                                    height="18"
                                  />
                                )}
                                {selectedDance.statusClass === "failed" && (
                                  <img
                                    src={FailedIcon}
                                    alt={t('common.fail')}
                                    width="18"
                                    height="18"
                                  />
                                )}
                              </span>
                              {t('danceLibrary.statusLabel')}:{" "}
                              {selectedDance.status === "pending"
                                ? t('danceLibrary.statusQueuing')
                                : selectedDance.status === "running"
                                ? t('danceLibrary.statusGenerating')
                                : selectedDance.status === "success"
                                  ? t('danceLibrary.statusCompleted')
                                  : selectedDance.status === "failed"
                                  ? t('danceLibrary.statusGenerationFailed')
                                  : selectedDance.status}
                            </div>
                            {/* 失败原因 */}
                            {selectedDance.status === "失败" && (
                              <div className="failure-reason">
                                {t('danceLibrary.failureReason')}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* 操作按钮 */}
                  {!isRetrying &&
                    selectedDance.status !== "生成中" &&
                    selectedDance.status !== "pending" &&
                    selectedDance.status !== "running" && (
                      <div className="dance-detail-actions">
                        {selectedDance.status === "已完成" ||
                        selectedDance.status === "success" ||
                        selectedDance.status === "SUCCESS" ? (
                          /* 已完成或生成成功状态显示立即启用按钮 */
                          <button

                            className="action-button deploy"
                            style={models.includes(selectedDance.model_id) ? { backgroundColor: "#2663EB7F" } : undefined}
                            onClick={() => {
                              if(models.includes(selectedDance.model_id)) {
                                Toast.info(t('danceLibrary.alreadyEnabled'))
                                return
                              }
                              if (isEnabling) return;  // 防止重复点击
                              setIsEnabling(false);
                              setShowConfirmDialog(true);
                            }}
                          >
                            {models.includes(selectedDance.model_id) ? t('danceLibrary.enabled') : t('danceLibrary.enableNow')}

                          </button>
                        ) : selectedDance.status === "失败" ? (
                          /* 失败状态显示再试一次和申请退款按钮 */
                          <>
                            <button
                              className="action-button retry"
                              onClick={() => setIsRetrying(true)}
                            >
                              {t('danceLibrary.retry')}
                            </button>
                            <button
                              className="action-button refund"
                              onClick={() => setShowRefundDialog(true)}
                            >
                              {t('danceLibrary.applyRefund')}
                            </button>
                          </>
                        ) : /* 其他状态不显示按钮 */
                        null}
                      </div>
                    )}
                </>
              )}
            </div>
          ) : activeNav === "dance" ? (
            /* 当选中舞蹈库但隐藏舞蹈列表时，显示欢迎页面 */
            <div className="empty-content">
              {/* 欢迎页面内容 */}
              <div className="welcome-section">
                {/* 播放按钮图标 */}
                <div className="play-button">
                  <img
                    className="play-button-icon"
                    src={PlayIcon}
                    alt={t('common.play')}
                  />
                </div>
                {/* 欢迎标题 */}
                <h2>{t('danceLibrary.welcome')}</h2>
                {/* 提示信息 */}
                <p>{t('danceLibrary.welcomeTip')}</p>
              </div>
            </div>
          ) : activeNav === "order" ? (
            /* 新增：订单页面 */
            selectedOrder ? (
              <div className="order-detail">
                {/* 订单详情页面 */}
                <h2>{t('order.detail')}</h2>
                {orderDetailLoading && (
                  <div className="order-loading-text">{t('order.detailLoading')}</div>
                )}
                <div className="order-detail-card">
                  <div className="order-detail-item">
                    <span className="order-detail-label">{t('order.orderNo')}</span>
                    <span className="order-detail-value">
                      {selectedOrder.orderNo}
                    </span>
                  </div>
                  <div className="order-detail-item">
                    <span className="order-detail-label">{t('order.name')}</span>
                    <span className="order-detail-value">
                      {selectedOrder.danceName}
                    </span>
                  </div>
                  <div className="order-detail-item">
                    <span className="order-detail-label">{t('order.createdAt')}</span>
                    <span className="order-detail-value">
                      {selectedOrder.createdAt}
                    </span>
                  </div>
                  <div className="order-detail-item">
                    <span className="order-detail-label">{t('order.status')}</span>
                    <span
                      className={`order-status ${
                        normalizeOrderStatus(selectedOrder.status) === "closed"
                          ? "failed"
                          : normalizeOrderStatus(selectedOrder.status) === "paid"
                            ? "completed"
                            : ""
                      }`}
                      style={{ fontSize: 12, fontWeight: 500 }}
                    >
                      {normalizeOrderStatus(selectedOrder.status) === "closed"
                        ? "✕ "
                        : ""}
                      {getOrderStatusText(selectedOrder.status)}
                    </span>
                  </div>

                  <div className="order-detail-divider"></div>

                  <div className="order-detail-item">
                    <span className="order-detail-label">{t('order.amount')}</span>
                    <span className="order-detail-value amount">
                      ¥{selectedOrder.amount}
                    </span>
                  </div>
                </div>
                
                {normalizeOrderStatus(selectedOrder.status) !== "paid" && (
                  <div className="order-detail-actions">
                    {normalizeOrderStatus(selectedOrder.status) === "pending" && (
                      <>
                        <button
                          className="cancel-order-button"
                          onClick={() => openOrderConfirmDialog("cancel")}
                        >
                          {t('order.cancelOrder')}
                        </button>
                        <button className="pay-order-button" onClick={handleGoPay}>
                          {t('order.goPay')}
                        </button>
                      </>
                    )}

                    {normalizeOrderStatus(selectedOrder.status) === "closed" && (
                      <button
                        className="cancel-order-button"
                        onClick={() => openOrderConfirmDialog("delete")}
                      >
                        {t('order.deleteOrder')}
                      </button>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="empty-content">
                <div className="order-management">
                  <div
                    className="order-icon"
                    style={{ backgroundImage: `url(${OrderIcon})` }}
                  ></div>
                  <h2>{t('order.title')}</h2>
                  <p>{t('order.selectTip')}</p>
                </div>
              </div>
            )
          ) : (
            /* 当未选中任何舞蹈项目时显示欢迎页面 */
            <div className="welcome-section">
              {/* 播放按钮图标 */}
              <div className="play-button">
                <img
                  className="play-button-icon"
                  src={PlayIcon}
                  alt={t('common.play')}
                />
              </div>
              {/* 欢迎标题 */}
              <h2>{t('danceLibrary.welcome')}</h2>
              {/* 提示信息 */}
              <p>{t('danceLibrary.welcomeTip')}</p>
            </div>
          )}
        </div>
      </div>
      {/* 订单操作确认弹框 */}
      {showOrderConfirmDialog && (
        <div className="order-confirm-overlay">
          <div className="order-confirm-dialog">
            <h3 className="order-confirm-title">
              {orderConfirmType === "delete"
                ? t('order.confirmDeleteTitle')
                : t('order.confirmCancelTitle')}
            </h3>
            <div className="order-confirm-actions">
              <button
                className="order-confirm-button secondary"
                onClick={closeOrderConfirmDialog}
              >
                {t('order.thinkAgain')}
              </button>
              <button
                className="order-confirm-button primary"
                onClick={handleOrderConfirm}
                disabled={orderActionLoading}
              >
                {orderActionLoading
                  ? t('common.processing')
                  : orderConfirmType === "delete"
                    ? t('order.confirmDelete')
                    : t('order.confirmCancel')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 退出登录确认弹框 */}
      {showLogoutDialog && (
        <div className="dialog-overlay" onClick={closeLogoutDialog}>
          <div
            className="delete-dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="dialog-title">{t('danceLibrary.logoutTitle')}</h3>
            <div className="dialog-buttons">
              <button
                className="dialog-button cancel"
                onClick={closeLogoutDialog}
                disabled={isLoggingOut}
              >
                {t('common.cancel')}
              </button>
              <button
                className="dialog-button confirm delete"
                onClick={confirmLogout}
                disabled={isLoggingOut}
              >
                {isLoggingOut ? t('danceLibrary.loggingOut') : t('danceLibrary.logoutConfirm')}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* 橡树果区域点击弹框 */}
      {showAcornDialog && (
        <div
          className="dialog-overlay"
          onClick={() => setShowAcornDialog(false)}
        >
          <div
            className={`acorn-dialog ${acornSubView ? "acorn-dialog-subview" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            {acornSubView === "rules" ? (
              <>
                <h3 className="dialog-title acorn-subview-title">{t('usageRules.title')}</h3>
                <div className="acorn-rules">
                  <ol className="acorn-rules-list">
                    {[
                      'purpose',
                      'consumptionStandard',
                      'consumptionOrder',
                      'validityPeriod',
                      'usageRestrictions',
                      'deductionInstructions',
                    ].map((key) => {
                      const text = t(`usageRules.${key}`);
                      const idx = text.search(/[:：]/);
                      const title = idx === -1 ? text : text.slice(0, idx + 1);
                      const desc = idx === -1 ? '' : text.slice(idx + 1).trim();
                      return (
                        <li key={key}>
                          <b>{title}</b>
                          {desc && <br />}
                          {desc}
                        </li>
                      );
                    })}
                  </ol>
                </div>
                <div className="dialog-buttons">
                  <button
                    className="dialog-button rules"
                    onClick={() => setAcornSubView(null)}
                  >
                    {t('usageRules.gotIt')}
                  </button>
                </div>
              </>
            ) : acornSubView === "agreement" ? (
              <>
                <h3 className="dialog-title acorn-subview-title">{t('rechargeAgreement.title')}</h3>
                <div className="acorn-rules">
                  <ol className="acorn-rules-list">
                    <li><b>{t('rechargeAgreement.homeRatioTitle')}</b><br />{t('rechargeAgreement.homeRatioBase')}</li>
                    {i18n.language === 'en' && (
                      <li className="rate-info">
                        <p className="rate-overseas">{t('rechargeAgreement.ratioOverseas')}</p>
                        <div className="rate-box">
                          {[
                            t('rechargeAgreement.ratioUSD'),
                            t('rechargeAgreement.ratioEUR'),
                            t('rechargeAgreement.ratioGBP'),
                            t('rechargeAgreement.ratioJPY'),
                            t('rechargeAgreement.ratioHKD'),
                          ].map((rate) => {
                            const eq = rate.indexOf('=');
                            return (
                              <div className="rate-row" key={rate}>
                                <span className="rate-currency">{rate.slice(0, eq).trim()}</span>
                                <span className="rate-value">
                                  <span className="rate-eq">=</span>
                                  <span className="rate-amount">{rate.slice(eq + 1).trim()}</span>
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </li>
                    )}
                    <li><b>{t('rechargeAgreement.homeMethodTitle')}</b><br />{t('rechargeAgreement.homeMethodDesc')}</li>
                    <li><b>{t('rechargeAgreement.homeNotesTitle')}</b><br />{t('rechargeAgreement.homeNotesDesc')}</li>
                  </ol>
                </div>
                <div className="dialog-buttons">
                  <button
                    className="dialog-button rules"
                    onClick={() => setAcornSubView(null)}
                  >
                    {t('common.iKnow')}
                  </button>
                </div>
              </>
            ) : (
              <>
                <span
                  className="acorn-rules-link"
                  onClick={() => setAcornSubView("rules")}
                >
                  {t('usageRules.viewRules')}
                </span>
                <img src={AcornIcon2}
                    alt={t('common.acorn')}
                    className="sidebar-acorn-icon"
                    width={36}
                    height={60}></img>
                <h3 className="dialog-title">
                  {acornDialogMode === "insufficient" ? t('balanceDialog.title') : t('rechargeDialog.title')}
                </h3>
                <p className="dialog-message">{t('rechargeDialog.desc')}</p>

                <div className="contact-box">
                  {i18n.language !== 'en' && (
                  <div className="contact-row">
                    <img
                      src={VxIcon}
                      alt={t('common.wechat')}
                      className="contact-icon"
                      width={17}
                      height={17}
                    />
                    <span className="contact-value">19072974147</span>
                    <span
                      className={`contact-copy-btn ${copiedField === "wechat" ? "copied" : ""}`}
                      onClick={() => copyToClipboard("19072974147", "wechat")}
                    >
                      {copiedField === "wechat" ? t('common.copied') : t('common.copy')}
                    </span>
                  </div>
                  )}

                  <div className="contact-row">
                    <img
                      src={YxIcon}
                      alt={t('common.email')}
                      className="contact-icon"
                      width={13}
                      height={13}
                    />
                    <span className="contact-value">support@oakcreektech.com</span>
                    <span
                      className={`contact-copy-btn ${copiedField === "email" ? "copied" : ""}`}
                      onClick={() => copyToClipboard("support@oakcreektech.com", "email")}
                    >
                      {copiedField === "email" ? t('common.copied') : t('common.copy')}
                    </span>
                  </div>
                </div>

                <div className="dialog-buttons">
                  {acornDialogMode === "insufficient" ? (
                    <button
                      className="dialog-button cancel"
                      onClick={() => setShowAcornDialog(false)}
                    >
                      {t('common.cancel')}
                    </button>
                  ) : (
                    <button
                      className="dialog-button confirm"
                      onClick={() => setShowAcornDialog(false)}
                    >
                      {t('common.gotIt')}
                    </button>
                  )}
                </div>

                <span
                  className="acorn-agreement-link"
                  onClick={() => setAcornSubView("agreement")}
                >
                  {t('rechargeDialog.viewAgreement')}
                </span>
              </>
            )}
          </div>
        </div>
      )}
      {/* 退款确认对话框 */}
      {showRefundDialog && (
        <div className="dialog-overlay">
          <div className="refund-dialog">
            {refundStatus === "confirm" ? (
              <>
                <div className="dialog-icon">
                  <span className="dialog-exclamation">!</span>
                </div>
                <h3 className="dialog-title">{t('refund.title')}</h3>
                <p className="dialog-message">
                  {t('refund.message')}
                </p>
                <div className="dialog-buttons">
                  <button
                    className="dialog-button cancel"
                    onClick={() => setShowRefundDialog(false)}
                  >
                    {t('common.cancel')}
                  </button>
                  <button
                    className="dialog-button confirm"
                    onClick={() => {
                      setRefundStatus("submitted");
                      // 3秒后关闭对话框并删除订单
                      setTimeout(() => {
                        setShowRefundDialog(false);
                        // 从舞蹈列表中删除该舞蹈项
                        if (selectedDance) {
                          setDances((prevDances) =>
                            prevDances.filter(
                              (dance) => dance.id !== selectedDance.id,
                            ),
                          );
                          setSelectedDance(null);
                          selectedDanceRef.current = null;
                          console.log("Deploying dance:", null);
                        }
                      }, 3000);
                    }}
                  >
                    {t('refund.confirm')}
                  </button>
                </div>
              </>
            ) : (
              <div className="refund-success">
                <div className="success-icon">
                  <span className="success-check">✓</span>
                </div>
                <h3 className="dialog-title">{t('refund.submitted')}</h3>
                <p className="dialog-message">{t('refund.submittedTip')}</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 确认启用对话框 */}
      {showConfirmDialog && (
  <div className="dialog-overlay">
    <div className="confirm-dialog">
      {!boosting ? (
        /* 确认启用对话框 */
        <>
          <div className="dialog-icon">
            <img src={CheckIcon} alt={t('common.check')} width="40" height="40" />
          </div>
          <h3 className="dialog-title">{t('danceLibrary.confirmEnable')}</h3>
          <p className="dialog-message">{t('danceLibrary.confirmEnableTip')}</p>
          <div className="dialog-buttons">
            <button
              className="dialog-button cancel"
              onClick={() => {
                setShowConfirmDialog(false);
                setIsEnabling(false);
                Toast.info(t('danceLibrary.enableCancelled'));
              }}
              disabled={isEnabling} // 添加禁用状态
            >
              {t('common.cancel')}
            </button>
            <button
  className="dialog-button confirm"
  disabled={isEnabling}
  style={{
    opacity: isEnabling ? 0.75 : 1,
    cursor: isEnabling ? "not-allowed" : "pointer",
  }}
  onClick={async () => {
    if (isEnabling) {
      return;
    }
    
    if (!selectedDance || !selectedDance.model_id) {
      Toast.info(t('danceLibrary.infoIncomplete'));
      return;
    }
    
    // ✅ 立即设置 loading 状态
    setIsEnabling(true);
    
    // ✅ 添加延迟，确保 React 有机会重新渲染
    await new Promise(resolve => setTimeout(resolve, 0));
    
    try {
      console.log("开始启用舞蹈...");
      
      // ✅ 添加调试信息
      console.log("检查原生桥接是否存在:", {
        isAndroid: /Android/i.test(navigator.userAgent),
        isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
        hasAndroidBridge: !!(window.NativeBridge && window.NativeBridge.postMessage),
        hasIOSBridge: !!(window.webkit?.messageHandlers?.nativeWithResult?.postMessage)
      });
      
      // ✅ 先检查是否能调用桥接
      // if (!isNativeBridgeAvailable()) {
      //   console.log("原生桥接不可用，使用模拟数据");
      //   // 模拟等待
      //   await new Promise(resolve => setTimeout(resolve, 2000));
      //   Toast.success("启用成功（模拟）");
      //   setShowConfirmDialog(false);
      //   setIsEnabling(false);
      //   return;
      // }
      
      // ✅ 尝试调用桥接

      
      console.log("获取到的模型列表:", models);
      
      const needDownload = !models.includes(selectedDance.model_id);
      
      if (needDownload) {
        console.log("需要下载模型，调用 getModelUrl...");
        await getModelUrl(selectedDance.model_id, selectedDance.task_name, selectedDance.cover_url, selectedDance.video_duration, selectedDance.media_id);
      } else {
        console.log("模型已存在");
        Toast.info(t('danceLibrary.alreadyAdded'));
        setShowConfirmDialog(false);
      }
      
    } catch (error) {
      console.error("启用过程中出错:", error);
      Toast.info(t('danceLibrary.operationFailed', { message: error.message || t('danceLibrary.pleaseRetry') }));
    } finally {
      // ✅ 最重要：无论成功还是失败，都要确保 loading 状态被清除
      setIsEnabling(false);
    }
  }}
>
  {isEnabling ? (
    <>
      <span className="loading-spinner" style={{
        display: "inline-block",
        width: "12px",
        height: "12px",
        border: "2px solid rgba(255,255,255,0.3)",
        borderTopColor: "white",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        marginRight: "8px",
        verticalAlign: "middle"
      }}></span>
      {t('danceLibrary.enabling')}
    </>
  ) : t('danceLibrary.confirmEnable')}
</button>
          </div>
        </>
      ) : (
        /* 加速页面 */
        <>
          <div className="dialog-icon">
            <span className="dialog-info">⚡</span>
          </div>
          <h3 className="dialog-title">{t('danceLibrary.boosting')}</h3>
          <p className="dialog-message">{t('danceLibrary.boostingTip')}</p>
          <div className="boost-progress-container">
            <div className="boost-progress-bar">
              <div
                className="boost-progress-fill"
                style={{ width: `${boostProgress}%` }}
              ></div>
            </div>
            <div className="boost-progress-text">{boostProgress}%</div>
          </div>
        </>
      )}
    </div>
  </div>
)}
      {/* 模拟预览提示框 */}
      {showSimulationDialog && (
        <div className="dialog-overlay">
          <div className="simulation-dialog">
            <div className="dialog-icon">
              <span className="dialog-info">i</span>
            </div>
            <h3 className="dialog-title">{t('simulation.title')}</h3>
            <p className="dialog-message">{t('simulation.message')}</p>
            <div className="dialog-buttons">
              <button
                className="dialog-button cancel"
                onClick={() => setShowSimulationDialog(false)}
              >
                {t('common.cancel')}
              </button>
              <button
                className="dialog-button confirm"
                onClick={() => setShowSimulationDialog(false)}
              >
                {t('common.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 上下文菜单 */}
      {contextMenuVisible && currentDance && (
        <div
          className="context-menu"
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
            zIndex: 9999,
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
          }}
        >
          <Menu
            style={{
              width: "110px",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: 0,
            }}
            items={[
              {
                key: "rename",
                label: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1px 1px 2px",
                    }}
                  >
                    <img
                      src={RenameIcon}
                      alt={t('danceLibrary.rename')}
                      width="18"
                      height="18"
                      style={{ marginRight: "8px" }}
                    />
                       <span style={{ color: "#374151" }}>{t('danceLibrary.rename')}</span>
                  </div>
                ),
                onClick: () => {
                  setContextMenuVisible(false);
                  setNewDanceName(currentDance?.name || "");
                  setShowRenameDialog(true);
                },
              },
              // 只有「生成失败」状态才显示删除，其余状态不提供删除入口
              ...(currentDance.status === "failed"
                ? [
                    {
                      type: "divider",
                    },
                    {
                      key: "delete",
                      label: (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "1px 1px 2px",
                          }}
                        >
                          <img
                            src={DeleteIcon}
                            alt={t('danceLibrary.delete')}
                            width="18"
                            height="18"
                            style={{ marginRight: "8px" }}
                          />
                          <span style={{ color: "#DC2627" }}>{t('danceLibrary.delete')}</span>
                        </div>
                      ),
                      danger: true,
                      onClick: () => {
                        setContextMenuVisible(false);
                        setShowDeleteDialog(true);
                      },
                    },
                  ]
                : []),
            ]}
          />
        </div>
      )}

      {/* 删除确认对话框 */}
      {showDeleteDialog && (
        <div className="dialog-overlay">
          <div className="delete-dialog">
            <h3 className="dialog-title">{t('danceLibrary.confirmDeleteTip')}</h3>
            <div className="dialog-buttons">
              <button
                className="dialog-button cancel"
                onClick={() => setShowDeleteDialog(false)}
              >
                {t('common.cancel')}
              </button>
              <button
                className="dialog-button confirm delete"
                onClick={() => {
                  // 关闭对话框
                  setShowDeleteDialog(false);
                  // 删除舞蹈数据
                  if (currentDance) {
                    if (isGeneratingStatus(currentDance.status)) {
                      alert(t('danceLibrary.cannotDeleteStatus'));
                      return;
                    }
                    // 调用 deleteTask 函数删除任务
                    deleteTask(currentDance.taskId);
                    // 清空当前舞蹈状态
                    setCurrentDance(null);
                  }
                }}
              >
                {t('danceLibrary.confirmDelete')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 重命名对话框 */}
      {showRenameDialog && (
        <div className="dialog-overlay">
          <div className="rename-dialog">
            <button
              className="rename-dialog-close"
              onClick={() => setShowRenameDialog(false)}
              aria-label={t('common.close')}
            >
              <img src={CloseIcon} alt={t('common.close')} />
            </button>
            <h3 className="dialog-title">{t('danceLibrary.modifyName')}</h3>
            <input
              type="text"
              className="rename-input"
              placeholder={t('danceLibrary.modifyNamePlaceholder')}
              value={newDanceName}
              onChange={(e) => setNewDanceName(e.target.value)}
            />
            <div className="dialog-buttons">
              <button
                className="dialog-button confirm"
                onClick={() => {
                  // 修改舞蹈名称
                  if (currentDance && newDanceName.trim()) {
                    console.log("Renaming dance:", currentDance, "New name:", newDanceName);
                    //隐藏当前弹窗
                    setShowRenameDialog(null)
                    //请求修改接口
                    requestRenameTask(currentDance.taskId, newDanceName.trim())
                  }
                }}
              >
                {t('common.save')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// 导出首页组件
export default Home;
